import { Typography } from '@mui/material';
import { Rating, Star, ThinStar } from '@smastrom/react-rating';
import { variants } from '../../../../variants/variants';

const customStyles = {
  itemShapes: Star,
  activeBoxColor: ['#e7040f', '#ff6300', '#ffde37', '#61bb00', '#19a974'],
  inactiveBoxColor: '#C7C7C7',
  inactiveFillColor: 'white',
  activeFillColor: 'white',
};
const FeedbackRating = ({ rating, handleRating, readOnly = false }) => {
  return (
    <div role='group' style={{ maxWidth: 250, width: '100%', margin: '0 auto', marginTop: '1rem' }}>
      {!readOnly && (
        <Typography sx={{ fontSize: variants.BODY, color: variants.typography.inactive.hover }}>
          Give an overall rating for this candidate
        </Typography>
      )}
      <Rating
        value={rating}
        onChange={handleRating}
        itemStyles={customStyles}
        spaceBetween='small'
        halfFillMode='box'
        transition='colors'
        {...(readOnly && readOnly)}
      />
    </div>
  );
};

export default FeedbackRating;
